import { AssetParams, createUrl } from '@mss/mss-component-library';
import Fetch from '../../util/_fetch';

export function deleteAsset(assetParams: AssetParams) {
  return Fetch.delete(createUrl(assetParams));
}
